import apiSecond from "../apiSecond";

const apiServiceSecond = {
  get(url) {
    return apiSecond.get(url, {
      headers: getSimpleHeaders(),
    });
  },
  post(url, body) {
    return apiSecond.post(url, body, {
      headers: getSimpleHeaders(),
    });
  },
  delete(url) {
    return apiSecond.delete(url, {
      headers: getSimpleHeaders(),
    });
  },

  getFromFile(url) {
    return apiSecond.get(url, {
      responseType: "blob",
      headers: getSimpleHeaders(),
    });
  },
};

function getSimpleHeaders() {
  const phpToken = localStorage.getItem("phpToken");
  return {
    "Content-Type": "application/json",
    Authorization: `${phpToken}`,
  };
}

export default apiServiceSecond;
